
import React from "react";
import Btn from "./common/Btn";
import TagBadge from "./common/TagBadge";
import { i18nManager } from "../i18n";
import { IMerchItem, MERCH } from "../data";
import SectionHeader from "./common/SectionHeader";
import styles from "../assets/style.module.css";
import { IProfileWebsite } from "../../../../services";

export interface StoreProps {
    website: IProfileWebsite;
    onAddToCart: (item: IMerchItem) => void;
}

function Store({ onAddToCart }: StoreProps) {

    const labels = i18nManager.Labels.store;

    return (<section className={`${styles["section"]} ${styles["page-inner"]}`}>
        <div className={styles["container"]}>
            <SectionHeader as="h1" eyebrow={labels.eyebrow} title={labels.title} titleEm={labels.title_em} subtitle={labels.desc} />
            <div className={styles["store-grid"]}>
                {MERCH.map((item) => (<div key={item.id} className={styles["product"]}>
                    <div className={styles["product-img-wrap"]}>
                        <img src={item.img} alt={item.name} loading="lazy" />
                        {item.badge && (<span className={styles["product-badge"]}><TagBadge>{item.badge}</TagBadge></span>)}
                    </div>
                    <div className={styles["product-body"]}>
                        <div className={styles["product-name"]}>{item.name}</div>
                        <div className={styles["product-foot"]}>
                            <div className={styles["product-price"]}>${item.price}</div>
                            <Btn size="sm" onClick={() => onAddToCart(item)}>{labels.add_to_cart}</Btn>
                        </div>
                    </div>
                </div>))}
            </div>
        </div>
    </section>);
}

export default Store;
